enum AttributionFootTrafficGraphReport {
  CampaignImpressions = 'attribution_foot_traffic_campaign_impressions',
  TotalStoreVisits = 'attribution_foot_traffic_total_store_visits',
  MEQ = 'attribution_foot_traffic_meq',
  Lift = 'attribution_foot_traffic_lift',
  ImpressionsAndFootTrafficVisits = 'attribution_foot_traffic_impressions_and_foot_traffic_visits',
  Gender = 'attribution_foot_traffic_gender',
  DayOfWeek = 'attribution_foot_traffic_day_of_week',
  HourOfDay = 'attribution_foot_traffic_hour_of_day',
}

export default AttributionFootTrafficGraphReport;
